<div class="flex flex-col gap-6 w-2/3">

  <!-- Visuals -->
  <div class="flex flex-col gap-4">
    <div class="ec-category-header">{{ 'settings.system.section.visuals' | translate }}</div>
    <app-card>
      <div>
        <label class="ec-toggle-label">
          <span class="flex items-center gap-2">
            {{ 'system.menu.darkmode' | translate }}
            <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-theme-primary text-white">Beta</span>
          </span>
          <app-toggle
            [ngModel]="themeService.isDark()"
            (ngModelChange)="themeService.toggle()"
          ></app-toggle>
        </label>
        <p class="text-xs text-gray-400 mt-1 px-1">
          {{ 'settings.system.darkmodeinfo' | translate }}
        </p>
      </div>
    </app-card>
  </div>

  <!-- Header -->
  <div class="flex flex-col gap-4">
    <div class="ec-category-header">{{ 'settings.system.section.header' | translate }}</div>
    <app-card>
      <div>
        <label class="ec-toggle-label">
          {{ 'settings.system.floatingheader' | translate }}
          <app-toggle
            [(ngModel)]="floatingHeader"
            (ngModelChange)="onFloatingHeaderChange($event)"
          ></app-toggle>
        </label>
        <p class="text-xs text-gray-400 mt-1 px-1">
          {{ 'settings.system.floatingheaderinfo' | translate }}
        </p>
      </div>
    </app-card>
  </div>

  <!-- Dashboard -->
  <div class="flex flex-col gap-4">
    <div class="ec-category-header">{{ 'settings.system.section.dashboard' | translate }}</div>
    <app-card>
      <div>
        <label class="ec-toggle-label">
          <span class="flex items-center gap-2">
            {{ 'settings.system.dashboard.computedgridloss' | translate }}
            <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-theme-primary text-white">Beta</span>
          </span>
          <app-toggle
            [(ngModel)]="dashboardComputedGridloss"
            (ngModelChange)="onDashboardComputedGridlossChange($event)"
          ></app-toggle>
        </label>
        <p class="text-xs text-gray-400 mt-1 px-1">
          {{ 'settings.system.dashboard.computedgridlossinfo' | translate }}
        </p>
      </div>
    </app-card>
  </div>

</div>
